<template>
  <div class="page page-savoir-faire">
    <PagesHomeHero v-if="page?.hero" :hero="page.hero" />

    <!-- Body -->
    <template v-if="page?.body && page.body?.length">
      <PagesCommonBody :body-items="page.body" :touch="touch" />
    </template>
  </div>
</template>

<script setup>
import queries from '@/graphql/dato/queries/index.js'
import pageTransition from '@/assets/js/transitions/helper.js'

definePageMeta({
  layout: 'default',
  pageTransition,
})

const { locale } = useI18n()

const touch = ref(false)

const query = queries.savoirFaire.getSavoirFaire
const variables = computed(() => ({
  locale: locale?.value ? locale.value : 'it',
}))

const { data } = await useGraphql(query, variables)

if (!data.value?.savoirFaire) {
  throw createError({ statusCode: 404 })
}

onMounted(() => {
  touch.value = 'ontouchstart' in window || !!navigator.maxTouchPoints /// !! trasformano 0/1 in Bool
})

const page = computed(() => data?.value?.savoirFaire)
const seo = computed(() => data?.value?.savoirFaire?.seo || {})

// Seo
useSeo({
  ...seo.value,
})
</script>
